import React from 'react';
import styled, { keyframes } from 'styled-components';
import {
	grey30,
	black,
	chartDarkGray,
	grey150,
	chartDullBlue,
	white,
} from 'styles/colors';

export const FileUploadContainer = styled.div`
	width: 100%;
	& > div:focus {
		outline: none;
	}
	margin-bottom: 24px;
`;

export const DropZoneArea = styled.div`
	display: flex;
	height: 180px;
	background-color: ${grey30};
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: 0 32px;
	margin: 24px 0;
`;

export const DropZoneText = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
`;

export const InitialText = styled.div`
	color: ${chartDarkGray};
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 19px;
	margin: auto;
	text-align: center;
`;
export const LeftAlignFlex = styled.div`
	align-self: flex-start;
`;

export const UploadProgressCounter = styled.span`
	font-size: 16px;
	letter-spacing: 0.3px;
	margin-left: auto;
	color: ${black};
	flex-shrink: 0;
	margin-left: 24px;
	display: flex;
	align-items: flex-end;
`;

const pulsate = keyframes`
	0% {
	  width: 5%;
	  opacity: 0.5;
	}
	100% {
	  width: 100%;
	  opacity: 0;
	}
`;

const UploadProgressInner = styled.div`
	width: ${({ value }) => value};
	border-radius: 2px;
	height: 24px;
	background-color: ${chartDullBlue};
	transition: width 0.2s;
`;

const FlashBar = styled.div`
	border-radius: 2px;
	height: 24px;
	background-color: ${white};
	transition: width 0.2s;

	animation: ${pulsate} 1.7s ease-out;
	animation-iteration-count: infinite;
`;

export const UploadProgressBar = styled(({ value, ...props }) => (
	<div {...props}>
		<UploadProgressInner value={`${value}%`}>
			<FlashBar />
		</UploadProgressInner>
	</div>
))`
	background: white;
	width: 100%;
	margin-top: 8px;
`;

export const DropWrapper = styled.div`
	outline: none;
	width: 100%;
	max-width: 950px;
	margin: 0 auto;
`;
export const ErrorTextWrapper = styled.div`
	border-bottom: 1px solid ${grey150};
	padding-bottom: 8px;
	width: 100%;
	margin-bottom: 15px;
`;

export const UploadTitleText = styled.div`
	font-size: 19px;
	color: ${black};
	font-weight: 500;
	margin-bottom: 25px;
	align-self: flex-start;
`;

export const UploadErrorText = styled(UploadTitleText)`
	margin-bottom: 14px;
`;

export const SuccessMessage = styled.div`
	letter-spacing: 0.3px;
	color: ${black};
	font-size: 19px;
	font-weight: 500;
	text-align: center;
`;

export const StatusText = styled.div`
	font-size: 16px;
	color: ${black};
	letter-spacing: 0.3px;
	flex-grow: 1;
`;

export const IconWrapper = styled.div`
	margin-bottom: 10px;
`;

export const ButtonWrapper = styled.div`
	margin: 10px auto 0 auto;
`;

export const ProgressText = styled.div`
	display: flex;
	width: 100%;
`;
